import { useEffect, useRef } from 'react';
import Button from '../../Atoms/Button';
import CtaLink from '../../Atoms/CtaLink';
import SelectedContractors from '../../Molecules/SelectedContractors';

const ContractorsModalContent = ({
  contractors,
  estimateLink,
  className,
  onRemove,
  contratorAddLink,
}) => {
  const ref = useRef(null);
  // Need this hook to update Modal triggers for new created buttons inside.
  useEffect(() => {
    if (window && Drupal?.behaviors?.modalJs) {
      Drupal.behaviors.modalJs.attach(ref.current);
    }
  }, [contractors.length, ref.current]);
  return (
    <div className={className} ref={ref}>
      <h2 className="h h3 text-blue">{Drupal.t('Get an Estimate')}</h2>
      <p className="modal-content-subtle">
        {Drupal.t(
          'Select up to three contractors to contact for a project estimate.',
        )}
      </p>
      {contractors.length > 0 ? (
        <>
          <h3 className="h h5">{Drupal.t('Contractors you’ve selected')}</h3>
          <SelectedContractors
            contractors={contractors}
            onRemove={(id) => onRemove(id)}
            contratorAddLink={contratorAddLink}
          />
          <CtaLink
            fieldCta={[
              { title: Drupal.t('Get an Estimate'), url: estimateLink },
            ]}
            mods={['primary']}
            extra={['modal-content-cta-btn']}
          />
        </>
      ) : (
        <>
          <p className="no-contractors-msg h h5">
            {Drupal.t('No contractors added yet.')}
            <br />
            {Drupal.t(
              'Select contractors from your results to get an estimate.',
            )}
          </p>
          <Button
            mods={['primary']}
            extra={['js-modal-close', 'modal-content-no-contractors-btn']}
          >
            {Drupal.t('See contractor results')}
          </Button>
        </>
      )}
    </div>
  );
};

export default ContractorsModalContent;
